import { Component, Input, OnInit } from '@angular/core';
import { GetUserLogin } from "../../../../auth/GetUserLogin";
import { GetWeeklyUpdateReportWeeks } from "../../../model/reports/weekly_update/GetWeeklyUpdateReportWeeks";
import { GetWeeklyUpdateReportProjects } from "../../../model/reports/weekly_update/GetWeeklyUpdateReportProjects";
import { GetProjects } from "../../../services/project-list/GetProjects";
import { GetUsers } from "../../../services/user/GetUsers";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { ProjectListService } from "../../../services/project-list/project-list.service";
import { UserService } from "../../../services/user/user.service";
import { WeeklyUpdateReportService } from "../../../services/reports/weekly-update-report.service";
import moment from 'moment';
import {ProjectStage} from "../../../model/general/ProjectStage";
import {MatSnackBar} from "@angular/material/snack-bar";
import {technologyToLabel} from '../../../model/general/Technology';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from '../../../../auth/auth.service';

@Component({
  selector: 'digires-weekly-report-project-table',
  templateUrl: './weekly-report-project-table.component.html',
  styleUrls: ['./weekly-report-project-table.component.scss']
})
export class WeeklyReportProjectTableComponent implements OnInit {

  destroy$: Subject<boolean> = new Subject<boolean>();

  readonly technologyToLabel = technologyToLabel;
  @Input() projectStage: ProjectStage.CONSTRUCTION | ProjectStage.POST_FID_FULL;
  @Input() projectsTableTitle: string;

  //arrays
  preConstructionWeeks: GetWeeklyUpdateReportWeeks[] = [];
  projectsOfSelectedWeek: GetWeeklyUpdateReportProjects[] = [];
  user: GetUsers[] = [];

  selectedWeek: GetWeeklyUpdateReportWeeks;
  weekFormGroup: FormGroup;

  areProjectsInitializing = false;

  currentSelectedWeek: string;

  constructor(private fb: FormBuilder,
    private projectService: ProjectListService,
    private userService: UserService,
    private snackBar: MatSnackBar,
    public weeklyUpdateReportService: WeeklyUpdateReportService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.startWeekFormGroup();
    this.initializeWeeks();
    // this.initializeCurrentLoggedinUser();
  }

  private startWeekFormGroup(): void {
    this.weekFormGroup = this.fb.group({
      week: new FormControl(null),
    });
  }

  private initializeWeeks(): void {
    let endpoint = null;

    if (this.projectStage === ProjectStage.CONSTRUCTION) {
      endpoint = "getAllConstructionReportWeeks";
    } else if (this.projectStage === ProjectStage.POST_FID_FULL) {
      endpoint = "getAllPreconstructionUpdateReportWeeks";
    }

    this.weeklyUpdateReportService[endpoint]()
      .then((result: GetWeeklyUpdateReportWeeks[]) => {
        this.preConstructionWeeks = result.sort((a, b) =>
          new Date(a.firstDay).getTime() - new Date(b.firstDay).getTime()
        );
        this.preSelectCurrentWeekWithProjects();
      })
      .catch(err => {
        console.log(err, "something went wrong")
      })
  }

  async initializeProjects(selectedWeek: GetWeeklyUpdateReportWeeks) {
    this.areProjectsInitializing = true;
    this.weeklyUpdateReportService.projects = [];
    const weekProjects: GetWeeklyUpdateReportProjects[] = [];
    const projectIds: string[] = [];
    const userIds: string[] = [];

    for (const project of selectedWeek.weeklyUpdateReportProjects) {
      projectIds.push(project.projectId);
      weekProjects.push(project);
    }

    let fetchedProjects: GetProjects[] = [];
    this.projectService.fetchProjectsByIds(projectIds).pipe(takeUntil(this.destroy$)).subscribe( async result => {
      fetchedProjects = result.loadedElements;
      if (!result.finished) return;
        for (const fetchedProject of fetchedProjects) {
          for (const weekProject of weekProjects) {
            if (fetchedProject.projectId !== weekProject.projectId) continue;
              // this.weeklyUpdateReportService.initializeProjects(fetchedProject);
              this.weeklyUpdateReportService.projects.push(fetchedProject);
              // await this.initializeUser(fetchedProject, weekProject);
              if (fetchedProject?.manager?.userId) {
                userIds.push(fetchedProject.manager.userId);
              }
              if (weekProject?.signedByUserId) {
                userIds.push(weekProject.signedByUserId);
              }
            }
        }

        this.userService.fetchUsersById(userIds).pipe(takeUntil(this.destroy$)).subscribe(user => {
          if (user.finished) {
            this.user = user.loadedElements;
            this.initializeCurrentLoggedInUser();

          }
          this.weeklyUpdateReportService.projects = this.weeklyUpdateReportService
            .projects.sort((a, b) => a.name.localeCompare(b.name));

          this.areProjectsInitializing = false;
        });
    });

  }

  private initializeCurrentLoggedInUser() {
    this.userService.loadUserById(this.authService.getUserId())
      .then((currentLoggedinUser) => {
        this.user.push(currentLoggedinUser);
      })
      .catch((error) => {
        console.log("Error loading user: " + error)
        this.snackBar.open('Failed to load current user.', 'Ok', { duration: 3000 });
      })
  }

  private async initializeUser(fetchedProject: GetProjects, project: GetWeeklyUpdateReportProjects) {
    //initializing all project manager
    const manager: GetUsers = null;
    if (fetchedProject?.manager?.userId) {
      this.userService.loadUserById(fetchedProject.manager.userId)
        .then((manager) => {
          this.user.push(manager);
        })
        .catch(error => {
          console.info('UserId not found')
          }
        )
    }

    //initializing all signed by user
    if (project?.signedByUserId) {
      this.userService.loadUserById(project?.signedByUserId)
        .then((signedBy) => {
          this.user.push(signedBy);
        })
        .catch(error => {
          console.info('UserId not found')
          }
        )
    }
  }

  getUser(project: GetProjects): GetUsers {
    if (!project?.manager) return null;

    const userObject = this.user.find(userElement => userElement.id === project.manager.userId);
    if (!userObject) return null;

    return userObject;
  }

  getSignedByUser(projectId: string): GetUsers {
    const weeklyUpdateReportProject: GetWeeklyUpdateReportProjects = this.getWeeklyUpdateReportProjectByProjectId(projectId);
    if (!weeklyUpdateReportProject) return null;

    const userObject = this.user.find(userElement => userElement?.id === weeklyUpdateReportProject?.signedByUserId);

    if (!userObject) return null;

    return userObject;
  }

  getWeeklyUpdateReportProjectByProjectId(projectId: string): GetWeeklyUpdateReportProjects {
    return this.projectsOfSelectedWeek.find(project => project?.projectId === projectId);
  }

  private preSelectCurrentWeekWithProjects(): void {
    const currentWeekNumber = parseInt(moment().format('w'));
    const currentYear = parseInt(moment().format('Y'));
    const yearWithWeekId = currentYear + "_" + (currentWeekNumber + 1);
    this.currentSelectedWeek = yearWithWeekId;
    const currentWeek = this.preConstructionWeeks.find(week => week.weekId === yearWithWeekId);
    this.selectWeekChange(currentWeek.weekId);
    this.weekFormGroup.get("week").setValue(yearWithWeekId);
  }

  getWeekLabel(week): string {
    return week && this.weeklyUpdateReportService.getWeekLabel(week);
  }

  async selectWeekChange(selectedWeekId: string) {
    if (!this.weeklyUpdateReportService.hasChanges) {
      await this.updateWeek(selectedWeekId);
    } else {
      this.weeklyUpdateReportService.openHasChangesDialog()
        .then((decision) => {
          if (decision) {
            this.updateWeek(selectedWeekId);
          } else {
            this.weekFormGroup.get("week").setValue(this.currentSelectedWeek)
          }
        })
    }
  }

  async updateWeek(selectedWeekId) {
    const selectedWeek = this.preConstructionWeeks.find(week => week.weekId === selectedWeekId);
    await this.initializeProjects(selectedWeek);
    this.projectsOfSelectedWeek = selectedWeek.weeklyUpdateReportProjects;

    //emit selected week to service
    this.weeklyUpdateReportService.setSelectedWeek(selectedWeek);
    this.selectedWeek = selectedWeek;
  }
}
